// extracted by mini-css-extract-plugin
module.exports = {"nav":"layout-module--nav--3pFmL","main":"layout-module--main--3N-7Z","footer":"layout-module--footer--bmfZq","layout":"layout-module--layout--2iqws"};